(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecom-sticky-cart"]) return;
  try {
    
;(function() {
  //Handle Sticky cart
  const doc = window.document,
        $main_atc_form = doc.querySelector('form[action="/cart/add"]');
  if(!$main_atc_form) {
    return;
  }
  const $el_wrapper = doc.querySelector('.ecom-sticky__atc'),
        layout_simple = $el_wrapper.classList.contains('ecom-sticky-layout__simple'),
        main_atc_btn = $main_atc_form.querySelector('button[type=submit]'),
        sticky_atc_btn = $el_wrapper.querySelector('.ecom-sticky__atc--btn');;

  const handleVariantStickyCart = function() {

    const $el = doc.querySelector('.ecom-sticky__atc--variants');
    const $main_variant_wrapper = doc.querySelector('.ecom-product-single__variant-picker');

    if (! $main_variant_wrapper) return;

    const selector = $main_variant_wrapper.querySelector('[name="id"]');
    const selector_id = selector.id;
    const sticky_selector_id = 'sticky-' + selector_id;
    let main_variant_html = null;

    if(!layout_simple) {
      main_variant_html = $main_variant_wrapper.querySelector('.ecom-product-single__variant-picker-wrapper').innerHTML;
    }

    if (! $el || ! $el_wrapper ) return;
    const json = $main_variant_wrapper.querySelector('#' + selector.dataset.jsonProduct);

    if (!json) {
        return;
    }
    if(!layout_simple) {
      main_variant_html = main_variant_html.replace(json.innerHTML, '');
    }

    let product = null;
    try {
        product = JSON.parse(json.innerHTML);
    } catch (e) {
        return;
    }

    if ( main_variant_html ) {
      let sticky_variant_html = main_variant_html.replaceAll( selector.id, sticky_selector_id);
      $el.innerHTML = sticky_variant_html;

      //Handle swatch select
      let swatch_items = $el.querySelectorAll('.ecom-product-single__swatch-item[data-option-index]');
      if (swatch_items) {
        for (const swatch_item of swatch_items) {
          swatch_item.addEventListener('click', function(e) {
            e.preventDefault();

            const _this = this;

            if (_this.classList.contains('ecom-button-active ecom-image-button')) {
              return;
            }

            let siblings = getSiblings(_this);
            if (siblings) {
              for(const sibling of siblings) {
                sibling.classList.remove('ecom-button-active', 'ecom-image-button');
              }
            }

            _this.classList.add('ecom-button-active', 'ecom-image-button');

            const index = _this.getAttribute('data-option-index');
            const select = $el.querySelector('select#' + sticky_selector_id + '-option-' + index);

            if (select) {
              select.value = _this.getAttribute('data-value');
              select.dispatchEvent(new Event('change') );
            }
          });
        } //End handle click swatch event

        //Handle select event
        let select_items = $el.querySelectorAll('.ecom-product-single__swatch-select');
        if (select_items) {
          for(select_item of select_items) {
            select_item.addEventListener('change', function(e) {
              e.preventDefault();
              const _this = this;
              const index = _this.getAttribute('data-option-index');
              const select = $el.querySelector('select#' + sticky_selector_id + '-option-' + index);

              if (select) {
                select.value = _this.value;
                select.dispatchEvent(new Event('change') );
              }
            });
          }
        } //End handle click swatch event
        const sticky_selector = $el.querySelector('[name="id"]');
        let select_wrappers = $el.querySelectorAll('.selector-wrapper').forEach( function(el) {
          el.remove();
        })
        const mySelector = new window.EComposer.OptionSelectors(sticky_selector.id, {
          product: product,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });

        function selectCallback(variant) {
          if (parseInt(selector.value) != parseInt(variant.id) ) {
            selector.value = variant.id;
            selector.dispatchEvent( new Event('swatch') );
          }
          updateSwatch(variant);
          updateOptionSelected(variant);
          updateImage(variant);
          updatePrice(variant);
          updateProductButtons(variant);
        }

        //Trigger when main form change value
        selector.addEventListener('change', function(event) {
          if ( parseInt(sticky_selector.value) !== parseInt(event.target.value) )
            mySelector.selectVariant(event.target.value);
        });

        //Update label
        function updateOptionSelected(variant) {
          const $container = $el.querySelector('.ecom-product-single__variant-picker-container');
          if (!$container || !variant) {
              return false;
          }

          $container.querySelectorAll('.ecom-product-single__variant-picker--selected-value').forEach(function(el) {
            el.remove();
          });

          const length = variant.options.length;
          const $doms = $container.querySelectorAll('.selector-wrapper');

          for (let i = 0; i < length; i++) {
            const newLabelDom = document.createElement('span');
            newLabelDom.className = 'ecom-product-single__variant-picker--selected-value';
            newLabelDom.innerText = ': ' + variant.options[i]

            let label =  $doms[i].querySelector(`label`);
            if (label) label.append(newLabelDom);

            let select_option = $container.querySelector(`select.ecom-product-single__swatch-select[data-option-index="${i}"]`);
            if  (select_option) select_option.value = variant.options[i];
          }
        }
      }
    } else {
      const selector_sticky = $el_wrapper.querySelector('select[name=id]');
      if(!selector_sticky) return;
      selector_sticky.addEventListener('change', function(e) {
        handleSimpleVariantChange();
      })
      handleSimpleVariantChange();

      function handleSimpleVariantChange() {
        let selected_index = selector_sticky.options[selector_sticky.selectedIndex];
          if ( ! selected_index ) return;
          let variant_id = selected_index.value;
          if(variant_id) {
            let variant = product.variants.find(variant => variant.id == variant_id);
            if(variant) {
              if (parseInt(selector.value) != parseInt(variant.id) ) {
                selector.value = variant.id;
                selector.dispatchEvent( new Event('swatch') );
              }
              updateImage(variant);
              updatePrice(variant);
              updateProductButtons(variant);
            }
          }
      }
      selector.addEventListener('change', function(event) {
        if ( parseInt(selector_sticky.value) !== parseInt(event.target.value) )
          selector_sticky.value = event.target.value;
          selector_sticky.dispatchEvent( new Event('change') );
      });
    }

    //Update thumbail image
    function updateImage(variant) {
      const $section = doc.querySelector('.ecom-sticky__atc');
      const image_wrapper = $section.querySelector('.ecom-sticky__atc--image');
      const image = $section.querySelector('.ecom-sticky__atc--image img');
      const image_size = $el_wrapper.getAttribute('data-img-size') || '100x';
      if (image && variant.featured_image != null ) {
        let image_src = window.EComposer.resizeImage(variant.featured_image.src, image_size);
        image_wrapper.classList.add('ecom-loading-image');
        image.setAttribute('src', image_src);

        image.onload = function() {
          image_wrapper.classList.remove('ecom-loading-image');
        }
      }
    }
    //Update price
    function updatePrice(variant) {
      const $section = doc.querySelector('.ecom-sticky__atc'),
            $price = $section.querySelector('.ecom-sticky__atc--price');

      if (variant) {
        const variant_price_sale = variant.compare_at_price != null ? variant.compare_at_price : variant.price,
              variant_price_regular = variant.price;

        if (variant_price_sale > variant_price_regular) {
          $price.innerHTML = `<del>${window.EComposer.formatMoney(variant_price_sale)}</del><ins>${window.EComposer.formatMoney(variant.price)}</ins>`;
        } else {
          $price.innerHTML = window.EComposer.formatMoney(variant.price);
        }
      }
    }

    function updateSwatch(variant) {
      if (variant && variant.options.length) {
          const $section = doc.querySelector('.ecom-sticky__atc');
          for (let i = 0; i < variant.options.length; i++) {
              $section.querySelectorAll(`.ecom-product-single__swatch-item[data-option-index="${i}"][data-value="${variant.options[i].replace(/'/g, '\'').replace(/"/g, '&quot;')}"]`)
              .forEach((element) => {
                  element.parentNode.childNodes.forEach(function(el){
                      if(el.classList)
                      {
                      el.classList.remove('ecom-box-active');
                      el.classList.remove('ecom-button-active');
                      el.classList.remove('ecom-image-active');
                      }
                  });
                  element.classList.add('ecom-box-active');
                  element.classList.add('ecom-button-active');
                  element.classList.add('ecom-image-active');
              });
              $section.querySelectorAll(`select.ecom-product-single__swatch-select[data-option-index="${i}"]`).forEach(function(el){
                  el.value = variant.options[i];
              })
          }
      }
    }
    //Update button
    function updateProductButtons(variant) {
      if (sticky_atc_btn) {
          if (!variant || !variant.available) {
              sticky_atc_btn.setAttribute('disabled', 'disabled');
              ecomStickyATCText();
          } else if (variant.available) {
              sticky_atc_btn.removeAttribute('disabled');
              ecomStickyATCText();
          } else {
              sticky_atc_btn.setAttribute('disabled', 'disabled');
              ecomStickyATCText();
          }
      }
    }
    let getSiblings = function (e) {
      // for collecting siblings
      let siblings = [];
      // if no parent, return no sibling
      if(!e.parentNode) {
          return siblings;
      }
      // first child of the parent node
      let sibling  = e.parentNode.firstChild;
      // collecting siblings
      while (sibling) {
          if (sibling.nodeType === 1 && sibling !== e) {
              siblings.push(sibling);
          }
          sibling = sibling.nextSibling;
      }
      return siblings;
    };
  };

  const handleSimpleVariant = function() {
    const selector = $el_wrapper.querySelector('select[name=ecom-sticky-cart__select]');
    if(!selector) return;
    selector.addEventListener('change', function(e) {
       let selected_index = selector.options[selector.selectedIndex];
        if ( ! selected_index ) return;

        const $main_variant_wrapper = doc.querySelector('.ecom-product-single__variant-picker');
        if (! $main_variant_wrapper) return;
        const selector = $main_variant_wrapper.querySelector('[name="id"]');

        let price = selected_index.getAttribute('data-price'),
            compare_at_price = selected_index.getAttribute('data-compare-price') || 0,
            image = selected_index.getAttribute('data-image'),
            available = selected_index.getAttribute('data-available'),
            product_id = selected_index.value;

        //Update image
        let item_image = $el_wrapper.querySelector('.ecom-sticky__atc--image');
        if(item_image) {
          item_image.classList.add('ecom-loading-image');
          item_image.querySelector('img').setAttribute('src', image);
          item_image.querySelector('img').onload = () => {
              item_image.classList.remove('ecom-loading-image');
          }
        }

        //Update price
        const $price = $el_wrapper.querySelector('.ecom-sticky__atc--price');
        if (price < compare_at_price) {
          $price.innerHTML = `<del>${window.EComposer.formatMoney(compare_at_price)}</del><ins>${window.EComposer.formatMoney(price)}</ins>`;
        } else {
          $price.innerHTML = window.EComposer.formatMoney(price);
        }

    })
  }
  const handleQuantity = function() {
    //Handle quantity
    const btn_qty_plus = $el_wrapper.querySelector('.ecom-plus');
    const btn_qty_minus = $el_wrapper.querySelector('.ecom-minus');
    const qty_input = $el_wrapper.querySelector('.ecom-qty-input');
    const main_qty_input = $main_atc_form.querySelector('.ecom-product-single__quantity-input');

    if (main_qty_input) {
      qty_input.addEventListener('change', function(e) {
        const value = this.value;
        if (main_qty_input != value) main_qty_input.value = value;
      })
      main_qty_input.addEventListener('change', function(e) {
        const value = this.value;
        if (main_qty_input != value) qty_input.value = value;
      })
    }

    if(btn_qty_plus) {
      btn_qty_plus.addEventListener('click', function(e) {
        e.preventDefault();
        changeQty('plus');
      })
    }
    if(btn_qty_minus) {
      btn_qty_minus.addEventListener('click', function(e) {
        e.preventDefault();
        changeQty('minus');
      })
    }

    const changeQty = function(type) {

      let currentVal = parseFloat(qty_input.value),
          max = parseFloat(qty_input.getAttribute('max')),
          min = parseFloat(qty_input.getAttribute('min')),
          step = qty_input.getAttribute('step');

      // Format values
       if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
       if (max === '' || max === 'NaN') max = '';
       if (min === '' || min === 'NaN') min = 0;
       if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;

       if (type == 'plus') {
        if (max && (currentVal >= max)) {
          qty_input.value = max;
        } else {
          qty_input.value = (currentVal + parseFloat(step)).toFixed();
          if (main_qty_input) main_qty_input.value = (currentVal + parseFloat(step)).toFixed();
        }
       } else {
        if (min && (currentVal <= min)) {
          qty_input.value = min;
        } else if (currentVal > 0) {
          qty_input.value = (currentVal - parseFloat(step)).toFixed();
          if (main_qty_input) main_qty_input.value = (currentVal - parseFloat(step)).toFixed();
        }
       }
    }
  }

  const handleATC = function() {
    //Handle Addtocart
    if (sticky_atc_btn) {
      sticky_atc_btn.addEventListener('click', function(e) {
        e.preventDefault();
        let _this = this;
        _this.classList.add('ecom-loading');
        if (main_atc_btn) {
          main_atc_btn.click();
        }

        setTimeout(function(){
          _this.classList.remove('ecom-loading');
        }, 500)
      });
    }
  }

  const ecomStickyCart = function() {
    const $sticky_wrapper = doc.querySelector('.ecom-sticky__atc');
    const main_btn_submit = $main_atc_form.querySelector('button[type=submit]');

    if(!$sticky_wrapper) return;

    if ( $sticky_wrapper && main_btn_submit ) {
      let summaryOffset = window.scrollY + main_btn_submit.getBoundingClientRect().top + main_btn_submit.offsetHeight;

      var stickyAddToCartToggle = function () {
        var windowScroll = window.pageYOffset || document.documentElement.scrollTop,
            windowHeight = window.innerHeight,
            documentHeight = document.body.clientHeight,
            totalScroll = parseInt(windowScroll + windowHeight) + 60;

        if (summaryOffset < windowScroll && totalScroll !== documentHeight && totalScroll < documentHeight) {
          $sticky_wrapper.classList.add('ecom-sticky-show');
        } else if (totalScroll === documentHeight || totalScroll > documentHeight || summaryOffset > windowScroll) {
          $sticky_wrapper.classList.remove('ecom-sticky-show');
        }
      };

      stickyAddToCartToggle();
      window.addEventListener('scroll', stickyAddToCartToggle);
    }
  }

  const ecomStickyStyle = function() {
    const qty = $el_wrapper.querySelector('.ecom-sticky__atc--quantity');

    if(main_atc_btn && sticky_atc_btn) {
      let btn_style = getComputedStyle(main_atc_btn);
      sticky_atc_btn.style.backgroundColor = btn_style.backgroundColor;
      sticky_atc_btn.style.color = btn_style.color;
      sticky_atc_btn.style.textTransform = btn_style.textTransform;
    }

    const swatch_color_main = $main_atc_form.querySelector('.ecom-product-single__picker-colors-item');
    const swatch_color_sticky = $el_wrapper.querySelectorAll('.ecom-product-single__picker-colors-item');

    if(swatch_color_main && swatch_color_sticky) {

      let btn_style = getComputedStyle(swatch_color_main);
      swatch_color_sticky.forEach(function(el) {
        el.style.borderRadius = btn_style.borderRadius;
      })
    }

    const swatch_select_main = $main_atc_form.querySelector('.ecom-product-single__picker-dropdown-list');
    const swatch_select_sticky = $el_wrapper.querySelectorAll('.ecom-product-single__picker-dropdown-list');

    if(swatch_select_main && swatch_select_sticky) {

      let btn_style = getComputedStyle(swatch_select_main);
      swatch_select_sticky.forEach(function(el) {
        el.style.borderRadius = btn_style.borderRadius;
      })
    }

  }

  const ecomStickyATCText = function() {
    if(main_atc_btn && sticky_atc_btn) {
      let atc_text = main_atc_btn && main_atc_btn.dataset.textAddCart ? main_atc_btn.dataset.textAddCart : '',
          outstock_text = main_atc_btn && main_atc_btn.dataset.textOutstock ? main_atc_btn.dataset.textOutstock : '';
      if(sticky_atc_btn.hasAttribute('disabled')) {
        sticky_atc_btn.querySelector('.ecom-add-to-cart-text').innerText = outstock_text;
      } else {
        sticky_atc_btn.querySelector('.ecom-add-to-cart-text').innerText = atc_text;
      }
    }
  }

  // Listen for `DOMContentLoaded` event
  document.addEventListener('DOMContentLoaded', function(e) {
    handleVariantStickyCart();
    handleQuantity();
    handleATC();
    ecomStickyCart();
    ecomStickyStyle();
    ecomStickyATCText()
  });

})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-about-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getVisibleVideo(media) {
      var videos = media.querySelectorAll('video');
      for (var i = 0; i < videos.length; i += 1) {
        if (window.getComputedStyle(videos[i]).display !== 'none') return videos[i];
      }
      return videos[0];
    }

    function setPlayButtonState(button, isPlaying) {
      button.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-label', isPlaying ? '暂停视频' : '播放视频');
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    function showPlayButton(video) {
      var media = video.closest('.x-about-story__media');
      var button = media && media.querySelector('[data-about-story-play]');
      if (button) setPlayButtonState(button, false);
    }

    function pauseOtherVideos(section, activeVideo) {
      section.querySelectorAll('.x-about-story__media video').forEach(function (video) {
        if (video !== activeVideo && !video.paused) video.pause();
      });
    }

    function toggleVideo(section, media) {
      var video = getVisibleVideo(media);
      var button = media.querySelector('[data-about-story-play]');
      if (!video) return;

      if (!video.paused) {
        video.pause();
        if (button) setPlayButtonState(button, false);
        return;
      }

      pauseOtherVideos(section, video);
      if (button) setPlayButtonState(button, true);
      video.play().catch(function () {
        if (button) setPlayButtonState(button, false);
      });
    }

    function bindVideos(section) {
      section.querySelectorAll('.x-about-story__media').forEach(function (media) {
        if (media.dataset.videoBound === 'true' || !media.querySelector('video')) return;
        media.dataset.videoBound = 'true';

        var button = media.querySelector('[data-about-story-play]');
        if (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            toggleVideo(section, media);
          });
          button.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
            toggleVideo(section, media);
          });
        }

        /* 点击视频区域任意位置均可播放/暂停 */
        media.addEventListener('click', function (event) {
          if (event.target.closest('[data-about-story-play]')) return;
          event.preventDefault();
          toggleVideo(section, media);
        });

        media.querySelectorAll('video').forEach(function (video) {
          video.addEventListener('pause', function () { showPlayButton(video); });
          video.addEventListener('ended', function () { showPlayButton(video); });
        });
      });
    }

    function initSection(section) {
      if (!section || section.dataset.aboutStoryInitialized === 'true') return;
      section.dataset.aboutStoryInitialized = 'true';
      bindVideos(section);
    }

    function init(root) {
      var scope = root || document;
      if (scope.matches && scope.matches('[data-section-type="x-about-story"]')) initSection(scope);
      scope.querySelectorAll('[data-section-type="x-about-story"]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-article-category-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-section-type="x-article-category-grid"]');

    sections.forEach(function (section) {
      const tabs = section.querySelectorAll('[data-tab-index][role="tab"]');
      const panels = section.querySelectorAll('[role="tabpanel"]');

      if (!tabs.length || !panels.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const tabIndex = tab.getAttribute('data-tab-index');

          tabs.forEach(function (item) {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function (panel) {
            if (panel.getAttribute('data-tab-index') === tabIndex) {
              panel.classList.add('is-active');
            } else {
              panel.classList.remove('is-active');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-belonging-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initSection = function (section) {
      if (!section || section.dataset.carouselInitialized === 'true' || !window.ClfCarousel) return;
      section.dataset.carouselInitialized = 'true';

      window.ClfCarousel.init(section, {
          breakpoint: '(min-width: 768px)',
          slideSelector: '.x-belonging-showcase__slide',
          dotClass: 'x-belonging-showcase__dot',
          ariaLabel: 'Go to page',
          onInit: function (section) {
            // 视频播放/暂停按钮：点击后切换同一张卡片内所有视频的播放/暂停状态，并显示/隐藏按钮
            const playTriggers = section.querySelectorAll('[data-play-video]');
            playTriggers.forEach(function (trigger) {
              if (trigger.dataset.videoBound === 'true') return;
              trigger.dataset.videoBound = 'true';
              const media = trigger.closest('.x-belonging-showcase__media');
              if (!media) return;
              const videos = media.querySelectorAll('video');

              const togglePlay = function (event) {
                if (event) {
                  event.preventDefault();
                  event.stopPropagation();
                }
                const isPlaying = Array.from(videos).some(function (video) {
                  return !video.paused;
                });
                if (isPlaying) {
                  videos.forEach(function (video) { video.pause(); });
                  trigger.classList.remove('is-hidden');
                } else {
                  videos.forEach(function (video) { video.play(); });
                  trigger.classList.add('is-hidden');
                }
              };

              trigger.addEventListener('click', togglePlay);
              trigger.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  togglePlay(event);
                }
              });

              // 点击视频 media 区域也能切换播放/暂停
              media.addEventListener('click', function (event) {
                if (event.target.closest('[data-play-video]')) return;
                togglePlay(event);
              });
            });
          }
        });
    };

    const init = function (root) {
      const scope = root || document;
      if (scope.matches && scope.matches('[data-section-type="x-belonging-showcase"]')) {
        initSection(scope);
      }
      scope.querySelectorAll('[data-section-type="x-belonging-showcase"]').forEach(initSection);
    };

    if (window.ClfCarousel) {
      init();
    } else {
      window.addEventListener('load', function () {
        init();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-section-type="x-collection-product-grid"]');

    sections.forEach(function (section) {
      const grid = section.querySelector('[data-product-grid]');
      const loadMoreButton = section.querySelector('[data-load-more]');
      const perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 12;

      const toggle = section.querySelector('[data-mobile-filter-toggle]');
      const drawer = section.querySelector('[data-mobile-filter-drawer]');
      const closeButtons = section.querySelectorAll('[data-mobile-filter-close]');

      const openDrawer = function () {
        if (!drawer) return;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
        }
        document.body.style.overflow = 'hidden';
      };

      const closeDrawer = function () {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
        document.body.style.overflow = '';
      };

      if (toggle && drawer) {
        toggle.addEventListener('click', openDrawer);
      }

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeDrawer);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
      cards.forEach(function (card, index) {
        card.classList.toggle('is-paginated', index >= perPage);
      });

      if (loadMoreButton) {
        const updateLoadMore = function () {
          const hasMore = grid.querySelectorAll('[data-product-card].is-paginated').length > 0;
          loadMoreButton.classList.toggle('is-hidden', !hasMore);
        };

        loadMoreButton.addEventListener('click', function () {
          const paginatedCards = Array.from(grid.querySelectorAll('[data-product-card].is-paginated'));
          let revealed = 0;
          paginatedCards.forEach(function (card) {
            if (revealed < perPage) {
              card.classList.remove('is-paginated');
              revealed++;
            }
          });
          updateLoadMore();
        });

        updateLoadMore();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-section-type="x-featured-products"]');
    const init = function () {
      sections.forEach(function (section) {
        if (section.classList.contains('x-featured-products--static-grid')) return;
        window.ClfCarousel.init(section, {
          breakpoint: '(min-width: 768px)',
          slideSelector: '.x-featured-products__slide',
          dotClass: 'x-featured-products__dot',
          ariaLabel: 'Go to page',
          stepMode: 'item',
          desktopDotCount: 5
        });
      });
    };
    if (window.ClfCarousel) {
      init();
    } else {
      window.addEventListener('load', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const footerMediaQuery = window.matchMedia('(max-width: 767px)');

    function syncFooterAccordion() {
      document.querySelectorAll('.x-footer__menu-details').forEach((details, index) => {
        if (footerMediaQuery.matches) {
          if (index === 0) {
            details.setAttribute('open', '');
          } else {
            details.removeAttribute('open');
          }
        } else {
          details.setAttribute('open', '');
        }
      });
    }

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.x-footer__menu-title');

      if (summary && !footerMediaQuery.matches) {
        event.preventDefault();
      }
    });

    syncFooterAccordion();
    footerMediaQuery.addEventListener('change', syncFooterAccordion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-header-backup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.getElementById('x-clf-header');
    if (!header) return;

    const scrollThreshold = 50;
    const desktopMedia = window.matchMedia('(min-width: 1024px)');
    const megaItems = Array.from(header.querySelectorAll('.x-header__menu-item--mega'));
    const overlay = header.querySelector('.x-header__overlay');
    let hoverCloseTimer;

    function updateHeader() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    // 在 cart 页面点击购物车图标只刷新当前页面，不打开抽屉
    const cartIcon = header.querySelector('.x-header__icon--cart-reload');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        location.reload();
      });
    }

    function closeMegaMenus(options) {
      megaItems.forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('.x-header__mega-trigger');
        const panel = item.querySelector('.x-header__mega-panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      });
      header.classList.remove('is-mega-open');
      if (overlay) overlay.classList.remove('is-active');
      if (options && options.restoreFocus && options.trigger) options.trigger.focus();
    }

    function openMegaMenu(item) {
      if (!desktopMedia.matches) return;
      clearTimeout(hoverCloseTimer);
      megaItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          const otherTrigger = otherItem.querySelector('.x-header__mega-trigger');
          const otherPanel = otherItem.querySelector('.x-header__mega-panel');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.setAttribute('aria-hidden', 'true');
        }
      });
      item.classList.add('is-open');
      header.classList.add('is-mega-open');
      const trigger = item.querySelector('.x-header__mega-trigger');
      const panel = item.querySelector('.x-header__mega-panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-active');

      // 桌面端 mega menu 内部 Tab 切换：默认激活第一个有内容的 Tab 和 Pane
      const tabs = item.querySelectorAll('.x-header__mega-tab');
      const panes = item.querySelectorAll('.x-header__mega-pane');
      if (tabs.length && panes.length) {
        // 找到第一个有内容的 pane 的索引
        let firstContentIndex = -1;
        panes.forEach((pane, index) => {
          if (firstContentIndex === -1 && pane.dataset.megaPaneHasContent === 'true') {
            firstContentIndex = index;
          }
        });
        tabs.forEach((tab, index) => {
          const isActive = index === firstContentIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });
        panes.forEach((pane, index) => {
          pane.classList.toggle('is-active', index === firstContentIndex);
        });
      }
    }

    megaItems.forEach((item) => {
      const trigger = item.querySelector('.x-header__mega-trigger');
      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        openMegaMenu(item);
      });
      item.addEventListener('mouseleave', function () {
        hoverCloseTimer = window.setTimeout(function () {
          closeMegaMenus();
        }, 120);
      });
      item.addEventListener('focusin', function () {
        openMegaMenu(item);
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeMegaMenus();
      });

      // 绑定 mega menu 内部 Tab 的 hover / focus 切换
      const tabs = item.querySelectorAll('.x-header__mega-tab');
      const panes = item.querySelectorAll('.x-header__mega-pane');
      tabs.forEach((tab) => {
        function activateTab() {
          const targetIndex = tab.dataset.megaTab;
          if (!targetIndex) return;
          tabs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          panes.forEach((pane) => {
            pane.classList.toggle('is-active', pane.dataset.megaPane === targetIndex);
          });
        }
        tab.addEventListener('mouseenter', activateTab);
        tab.addEventListener('focus', activateTab);
      });
    });

    if (overlay) {
      overlay.addEventListener('mouseenter', function () {
        // 鼠标进入遮罩层时立即关闭超级菜单
        closeMegaMenus();
      });
      overlay.addEventListener('click', function () {
        closeMegaMenus();
      });
    }

    const toggle = header.querySelector('.x-header__menu-toggle');
    const mobileMenu = document.getElementById('x-clf-mobile-menu');
    const mobileTrack = mobileMenu ? mobileMenu.querySelector('.x-header__mobile-track') : null;
    const rootPanel = mobileMenu ? mobileMenu.querySelector('[data-mobile-panel="root"]') : null;
    let activeMobileTrigger = null;

    function resetMobilePanels() {
      if (!mobileTrack) return;
      mobileTrack.classList.remove('is-drilled');
      mobileMenu.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        const isRoot = panel === rootPanel;
        panel.classList.toggle('is-active', isRoot);
        panel.setAttribute('aria-hidden', String(!isRoot));
        panel.inert = !isRoot;
      });
      mobileMenu.querySelectorAll('[data-mobile-panel-target]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      activeMobileTrigger = null;
    }

    if (toggle && mobileMenu) {
      function setMenuOpen(isOpen) {
        mobileMenu.classList.toggle('is-open', isOpen);
        mobileMenu.setAttribute('aria-hidden', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.classList.toggle('is-active', isOpen);
        document.body.classList.toggle('x-header__menu-open', isOpen);
        document.documentElement.classList.toggle('x-header__menu-open', isOpen);
        if (isOpen) {
          closeMegaMenus();
          window.requestAnimationFrame(function () {
            const firstControl = mobileMenu.querySelector('a, button');
            if (firstControl) firstControl.focus();
          });
        } else {
          resetMobilePanels();
          toggle.focus();
        }
      }

      toggle.addEventListener('click', function () {
        setMenuOpen(!mobileMenu.classList.contains('is-open'));
      });

      mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', function () {
          setMenuOpen(false);
        });
      });

      mobileMenu.querySelectorAll('[data-mobile-panel-target]').forEach((panelTrigger) => {
        panelTrigger.addEventListener('click', function () {
          const target = mobileMenu.querySelector('[data-mobile-panel="' + panelTrigger.dataset.mobilePanelTarget + '"]');
          if (!target || !mobileTrack) return;
          activeMobileTrigger = panelTrigger;
          panelTrigger.setAttribute('aria-expanded', 'true');
          rootPanel.setAttribute('aria-hidden', 'true');
          rootPanel.inert = true;
          target.classList.add('is-active');
          target.setAttribute('aria-hidden', 'false');
          target.inert = false;
          mobileTrack.classList.add('is-drilled');
          const backButton = target.querySelector('[data-mobile-panel-back]');
          if (backButton) backButton.focus();
        });
      });

      mobileMenu.querySelectorAll('[data-mobile-panel-back]').forEach((backButton) => {
        backButton.addEventListener('click', function () {
          const triggerToRestore = activeMobileTrigger;
          resetMobilePanels();
          if (triggerToRestore) triggerToRestore.focus();
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          if (mobileMenu.classList.contains('is-open')) {
            setMenuOpen(false);
          } else {
            closeMegaMenus();
          }
        }
      });

      desktopMedia.addEventListener('change', function () {
        setMenuOpen(false);
        closeMegaMenus();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.getElementById('x-clf-header');
    if (!header) return;

    const scrollThreshold = 50;
    const desktopMedia = window.matchMedia('(min-width: 1024px)');
    const megaItems = Array.from(header.querySelectorAll('.x-header__menu-item--mega'));
    const overlay = header.querySelector('.x-header__overlay');
    let hoverCloseTimer;

    function updateHeader() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    // 在 cart 页面点击购物车图标只刷新当前页面，不打开抽屉
    const cartIcon = header.querySelector('.x-header__icon--cart-reload');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        location.reload();
      });
    }

    function closeMegaMenus(options) {
      megaItems.forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('.x-header__mega-trigger');
        const panel = item.querySelector('.x-header__mega-panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      });
      header.classList.remove('is-mega-open');
      if (overlay) overlay.classList.remove('is-active');
      if (options && options.restoreFocus && options.trigger) options.trigger.focus();
    }

    function openMegaMenu(item) {
      if (!desktopMedia.matches) return;
      clearTimeout(hoverCloseTimer);
      megaItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          const otherTrigger = otherItem.querySelector('.x-header__mega-trigger');
          const otherPanel = otherItem.querySelector('.x-header__mega-panel');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.setAttribute('aria-hidden', 'true');
        }
      });
      item.classList.add('is-open');
      header.classList.add('is-mega-open');
      const trigger = item.querySelector('.x-header__mega-trigger');
      const panel = item.querySelector('.x-header__mega-panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-active');

      // 桌面端 mega menu 内部 Tab 切换：默认激活第一个有内容的 Tab 和 Pane
      const tabs = item.querySelectorAll('.x-header__mega-tab');
      const panes = item.querySelectorAll('.x-header__mega-pane');
      if (tabs.length && panes.length) {
        // 找到第一个有内容的 pane 的索引
        let firstContentIndex = -1;
        panes.forEach((pane, index) => {
          if (firstContentIndex === -1 && pane.dataset.megaPaneHasContent === 'true') {
            firstContentIndex = index;
          }
        });
        tabs.forEach((tab, index) => {
          const isActive = index === firstContentIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });
        panes.forEach((pane, index) => {
          pane.classList.toggle('is-active', index === firstContentIndex);
        });
      }
    }

    megaItems.forEach((item) => {
      const trigger = item.querySelector('.x-header__mega-trigger');
      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        openMegaMenu(item);
      });
      item.addEventListener('mouseleave', function () {
        hoverCloseTimer = window.setTimeout(function () {
          closeMegaMenus();
        }, 120);
      });
      item.addEventListener('focusin', function () {
        openMegaMenu(item);
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeMegaMenus();
      });

      // 绑定 mega menu 内部 Tab 的 hover / focus 切换
      const tabs = item.querySelectorAll('.x-header__mega-tab');
      const panes = item.querySelectorAll('.x-header__mega-pane');
      tabs.forEach((tab) => {
        function activateTab() {
          const targetIndex = tab.dataset.megaTab;
          if (!targetIndex) return;
          tabs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          panes.forEach((pane) => {
            pane.classList.toggle('is-active', pane.dataset.megaPane === targetIndex);
          });
        }
        tab.addEventListener('mouseenter', activateTab);
        tab.addEventListener('focus', activateTab);
      });
    });

    if (overlay) {
      overlay.addEventListener('mouseenter', function () {
        // 鼠标进入遮罩层时立即关闭超级菜单
        closeMegaMenus();
      });
      overlay.addEventListener('click', function () {
        closeMegaMenus();
      });
    }

    const toggle = header.querySelector('.x-header__menu-toggle');
    const mobileMenu = document.getElementById('x-clf-mobile-menu');
    const mobileTrack = mobileMenu ? mobileMenu.querySelector('.x-header__mobile-track') : null;
    const rootPanel = mobileMenu ? mobileMenu.querySelector('[data-mobile-panel="root"]') : null;
    let activeMobileTrigger = null;

    function resetMobilePanels() {
      if (!mobileTrack) return;
      mobileTrack.classList.remove('is-drilled');
      mobileMenu.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        const isRoot = panel === rootPanel;
        panel.classList.toggle('is-active', isRoot);
        panel.setAttribute('aria-hidden', String(!isRoot));
        panel.inert = !isRoot;
      });
      mobileMenu.querySelectorAll('[data-mobile-panel-target]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      activeMobileTrigger = null;
    }

    if (toggle && mobileMenu) {
      function setMenuOpen(isOpen) {
        mobileMenu.classList.toggle('is-open', isOpen);
        mobileMenu.setAttribute('aria-hidden', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.classList.toggle('is-active', isOpen);
        document.body.classList.toggle('x-header__menu-open', isOpen);
        document.documentElement.classList.toggle('x-header__menu-open', isOpen);
        if (isOpen) {
          closeMegaMenus();
          window.requestAnimationFrame(function () {
            const firstControl = mobileMenu.querySelector('a, button');
            if (firstControl) firstControl.focus();
          });
        } else {
          resetMobilePanels();
          toggle.focus();
        }
      }

      toggle.addEventListener('click', function () {
        setMenuOpen(!mobileMenu.classList.contains('is-open'));
      });

      mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', function () {
          setMenuOpen(false);
        });
      });

      mobileMenu.querySelectorAll('[data-mobile-panel-target]').forEach((panelTrigger) => {
        panelTrigger.addEventListener('click', function () {
          const target = mobileMenu.querySelector('[data-mobile-panel="' + panelTrigger.dataset.mobilePanelTarget + '"]');
          if (!target || !mobileTrack) return;
          activeMobileTrigger = panelTrigger;
          panelTrigger.setAttribute('aria-expanded', 'true');
          rootPanel.setAttribute('aria-hidden', 'true');
          rootPanel.inert = true;
          target.classList.add('is-active');
          target.setAttribute('aria-hidden', 'false');
          target.inert = false;
          mobileTrack.classList.add('is-drilled');
          const backButton = target.querySelector('[data-mobile-panel-back]');
          if (backButton) backButton.focus();
        });
      });

      mobileMenu.querySelectorAll('[data-mobile-panel-back]').forEach((backButton) => {
        backButton.addEventListener('click', function () {
          const triggerToRestore = activeMobileTrigger;
          resetMobilePanels();
          if (triggerToRestore) triggerToRestore.focus();
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          if (mobileMenu.classList.contains('is-open')) {
            setMenuOpen(false);
          } else {
            closeMegaMenus();
          }
        }
      });

      desktopMedia.addEventListener('change', function () {
        setMenuOpen(false);
        closeMegaMenus();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-homeowner-tour"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getVisibleVideo(media) {
      var videos = media.querySelectorAll('video');
      for (var i = 0; i < videos.length; i += 1) {
        if (window.getComputedStyle(videos[i]).display !== 'none') return videos[i];
      }
      return videos[0];
    }

    function showPlayButton(video) {
      var media = video.closest('.x-homeowner-tour__media');
      var button = media && media.querySelector('[data-homeowner-tour-play]');
      if (button) setPlayButtonState(button, false);
    }

    function setPlayButtonState(button, isPlaying) {
      button.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-label', isPlaying ? '暂停视频' : '播放视频');
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    function resetExternalVideo(media) {
      var iframe = media.querySelector('iframe');
      if (iframe) iframe.remove();
      media.classList.remove('is-embed');
      delete media.dataset.embedLoaded;
      var button = media.querySelector('[data-homeowner-tour-play]');
      if (button) setPlayButtonState(button, false);
    }

    function resetAllExternalVideos(section, exceptMedia) {
      section.querySelectorAll('[data-external-video]').forEach(function (media) {
        if (media !== exceptMedia && media.dataset.embedLoaded === 'true') resetExternalVideo(media);
      });
    }

    function loadExternalVideo(section, media) {
      if (media.dataset.embedLoaded === 'true') {
        resetExternalVideo(media);
        return;
      }

      var src = media.getAttribute('data-embed-src');
      if (!src) return;

      section.querySelectorAll('.x-homeowner-tour__media video').forEach(function (video) {
        if (!video.paused) video.pause();
      });
      resetAllExternalVideos(section, media);

      var provider = media.getAttribute('data-provider');
      var iframe = document.createElement('iframe');
      if (provider === 'youtube') {
        src += '?autoplay=1&playsinline=1&rel=0&iv_load_policy=3';
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      } else {
        src += '?embed_captioned=false&hl=en';
        iframe.setAttribute('scrolling', 'no');
      }
      iframe.className = 'x-homeowner-tour__embed';
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', media.getAttribute('data-video-title') || '视频');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('allowfullscreen', '');
      media.appendChild(iframe);
      media.classList.add('is-embed');
      media.dataset.embedLoaded = 'true';
    }

    function pauseOtherVideos(section, activeVideo) {
      section.querySelectorAll('.x-homeowner-tour__media video').forEach(function (video) {
        if (video !== activeVideo && !video.paused) video.pause();
      });
      resetAllExternalVideos(section, activeVideo ? activeVideo.closest('[data-external-video]') : null);
    }

    function toggleVideo(section, media) {
      var video = getVisibleVideo(media);
      var button = media.querySelector('[data-homeowner-tour-play]');
      if (!video) return;

      if (!video.paused) {
        video.pause();
        if (button) setPlayButtonState(button, false);
        return;
      }

      pauseOtherVideos(section, video);
      if (button) setPlayButtonState(button, true);
      media.classList.add('has-started');
      video.controls = true;
      video.play().catch(function () {
        if (button) setPlayButtonState(button, false);
      });
    }

    function bindVideos(section) {
      section.querySelectorAll('.x-homeowner-tour__media').forEach(function (media) {
        if (media.dataset.videoBound === 'true') return;
        media.dataset.videoBound = 'true';

        var button = media.querySelector('[data-homeowner-tour-play]');
        if (button) {
          var activateMedia = function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (media.hasAttribute('data-external-video')) {
              loadExternalVideo(section, media);
              return;
            }
            toggleVideo(section, media);
          };
          button.addEventListener('click', activateMedia);
          button.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            activateMedia(event);
          });
        }

        media.addEventListener('click', function (event) {
          if (event.target.closest('[data-homeowner-tour-play]')) return;
          event.preventDefault();
          if (media.hasAttribute('data-external-video')) {
            loadExternalVideo(section, media);
            return;
          }
          toggleVideo(section, media);
        });

        media.querySelectorAll('video').forEach(function (video) {
          video.addEventListener('pause', function () { showPlayButton(video); });
          video.addEventListener('ended', function () { showPlayButton(video); });
        });
      });
    }

    function bindMoreButtons(section) {
      section.querySelectorAll('[data-homeowner-tour-more]').forEach(function (button) {
        if (button.dataset.moreBound === 'true') return;
        button.dataset.moreBound = 'true';

        button.addEventListener('click', function () {
          var group = button.closest('.x-homeowner-tour__group');
          if (!group) return;
          group.classList.add('is-expanded');
          button.setAttribute('aria-expanded', 'true');
          var wrapper = button.closest('.x-homeowner-tour__more');
          if (wrapper) wrapper.classList.add('is-hidden');
        });
      });
    }

    function initSection(section) {
      if (!section || section.dataset.homeownerInitialized === 'true' || !window.ClfCarousel) return;
      section.dataset.homeownerInitialized = 'true';

      section.querySelectorAll('[data-homeowner-carousel]').forEach(function (carousel) {
        if (carousel.dataset.carouselInitialized === 'true') return;
        carousel.dataset.carouselInitialized = 'true';
        window.ClfCarousel.init(carousel, {
          breakpoint: '(min-width: 750px)',
          slideSelector: '.x-homeowner-tour__slide',
          dotClass: 'x-homeowner-tour__dot',
          ariaLabel: '前往第',
          stepMode: 'page'
        });
      });

      bindVideos(section);
      bindMoreButtons(section);
    }

    function init(root) {
      var scope = root || document;
      if (scope.matches && scope.matches('[data-section-type="x-homeowner-tour"]')) initSection(scope);
      scope.querySelectorAll('[data-section-type="x-homeowner-tour"]').forEach(initSection);
    }

    function start(root) {
      if (window.ClfCarousel) {
        init(root);
      } else {
        window.addEventListener('load', function () { init(root); }, { once: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { start(); }, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function (event) {
      start(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-new-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.getElementById('x-clf-header');
    if (!header) return;

    const scrollThreshold = 50;
    const desktopMedia = window.matchMedia('(min-width: 1024px)');
    const megaItems = Array.from(header.querySelectorAll('.x-header__menu-item--mega'));
    const overlay = header.querySelector('.x-header__overlay');
    let hoverCloseTimer;

    function updateHeader() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    // 在 cart 页面点击购物车图标只刷新当前页面，不打开抽屉
    const cartIcon = header.querySelector('.x-header__icon--cart-reload');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        location.reload();
      });
    }

    function closeMegaMenus(options) {
      megaItems.forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('.x-header__mega-trigger');
        const panel = item.querySelector('.x-header__mega-panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      });
      header.classList.remove('is-mega-open');
      header.style.removeProperty('--x-mega-panel-height');
      if (overlay) overlay.classList.remove('is-active');
      if (options && options.restoreFocus && options.trigger) options.trigger.focus();
    }

    function openMegaMenu(item) {
      if (!desktopMedia.matches) return;
      clearTimeout(hoverCloseTimer);
      megaItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          const otherTrigger = otherItem.querySelector('.x-header__mega-trigger');
          const otherPanel = otherItem.querySelector('.x-header__mega-panel');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.setAttribute('aria-hidden', 'true');
        }
      });
      item.classList.add('is-open');
      header.classList.add('is-mega-open');
      const trigger = item.querySelector('.x-header__mega-trigger');
      const panel = item.querySelector('.x-header__mega-panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.setAttribute('aria-hidden', 'false');
        header.style.setProperty('--x-mega-panel-height', panel.offsetHeight + 'px');
      }
      if (overlay) overlay.classList.add('is-active');
    }

    window.addEventListener('resize', function () {
      const openPanel = header.querySelector('.x-header__menu-item--mega.is-open .x-header__mega-panel');
      if (openPanel) {
        header.style.setProperty('--x-mega-panel-height', openPanel.offsetHeight + 'px');
      }
    }, { passive: true });

    megaItems.forEach((item) => {
      const trigger = item.querySelector('.x-header__mega-trigger');
      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        openMegaMenu(item);
      });
      item.addEventListener('mouseleave', function () {
        hoverCloseTimer = window.setTimeout(function () {
          closeMegaMenus();
        }, 120);
      });
      item.addEventListener('focusin', function () {
        openMegaMenu(item);
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeMegaMenus();
      });
    });

    if (overlay) {
      overlay.addEventListener('mouseenter', function () {
        // 鼠标进入遮罩层时立即关闭超级菜单
        closeMegaMenus();
      });
      overlay.addEventListener('click', function () {
        closeMegaMenus();
      });
    }

    const toggle = header.querySelector('.x-header__menu-toggle');
    const mobileMenu = document.getElementById('x-clf-mobile-menu');
    const mobileTrack = mobileMenu ? mobileMenu.querySelector('.x-header__mobile-track') : null;
    const rootPanel = mobileMenu ? mobileMenu.querySelector('[data-mobile-panel="root"]') : null;
    let activeMobileTrigger = null;

    function resetMobilePanels() {
      if (!mobileTrack) return;
      mobileTrack.classList.remove('is-drilled');
      mobileMenu.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        const isRoot = panel === rootPanel;
        panel.classList.toggle('is-active', isRoot);
        panel.setAttribute('aria-hidden', String(!isRoot));
        panel.inert = !isRoot;
      });
      mobileMenu.querySelectorAll('[data-mobile-panel-target]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      activeMobileTrigger = null;
    }

    if (toggle && mobileMenu) {
      function setMenuOpen(isOpen) {
        mobileMenu.classList.toggle('is-open', isOpen);
        mobileMenu.setAttribute('aria-hidden', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.classList.toggle('is-active', isOpen);
        document.body.classList.toggle('x-header__menu-open', isOpen);
        document.documentElement.classList.toggle('x-header__menu-open', isOpen);
        if (isOpen) {
          closeMegaMenus();
          window.requestAnimationFrame(function () {
            const firstControl = mobileMenu.querySelector('a, button');
            if (firstControl) firstControl.focus();
          });
        } else {
          resetMobilePanels();
          toggle.focus();
        }
      }

      toggle.addEventListener('click', function () {
        setMenuOpen(!mobileMenu.classList.contains('is-open'));
      });

      mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', function () {
          setMenuOpen(false);
        });
      });

      mobileMenu.querySelectorAll('[data-mobile-panel-target]').forEach((panelTrigger) => {
        panelTrigger.addEventListener('click', function () {
          const target = mobileMenu.querySelector('[data-mobile-panel="' + panelTrigger.dataset.mobilePanelTarget + '"]');
          if (!target || !mobileTrack) return;
          activeMobileTrigger = panelTrigger;
          panelTrigger.setAttribute('aria-expanded', 'true');
          rootPanel.setAttribute('aria-hidden', 'true');
          rootPanel.inert = true;
          target.classList.add('is-active');
          target.setAttribute('aria-hidden', 'false');
          target.inert = false;
          mobileTrack.classList.add('is-drilled');
          const backButton = target.querySelector('[data-mobile-panel-back]');
          if (backButton) backButton.focus();
        });
      });

      // 子菜单：点击加减号图标折叠/展开，点击名字跳转（链接行为不受影响）
      mobileMenu.querySelectorAll('.x-header__mobile-nested-toggle').forEach((nestedToggle) => {
        nestedToggle.addEventListener('click', function () {
          const nested = nestedToggle.closest('.x-header__mobile-nested');
          if (!nested) return;
          const isOpen = nested.classList.toggle('is-open');
          nestedToggle.setAttribute('aria-expanded', String(isOpen));
        });
      });

      mobileMenu.querySelectorAll('[data-mobile-panel-back]').forEach((backButton) => {
        backButton.addEventListener('click', function () {
          const triggerToRestore = activeMobileTrigger;
          resetMobilePanels();
          if (triggerToRestore) triggerToRestore.focus();
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          if (mobileMenu.classList.contains('is-open')) {
            setMenuOpen(false);
          } else {
            closeMegaMenus();
          }
        }
      });

      desktopMedia.addEventListener('change', function () {
        setMenuOpen(false);
        closeMegaMenus();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-partner-inquiry"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initForm = function (form) {
      if (!form || form.dataset.partnerValidationInitialized === 'true') return;
      form.dataset.partnerValidationInitialized = 'true';

      const fields = form.querySelectorAll('input, textarea');
      const submitButton = form.querySelector('.x-partner-inquiry__submit');

      const blockInvalidSubmit = function (event) {
        if (form.checkValidity()) return;

        // 必须在 click 阶段拦截：Shopify 的 hCaptcha 防机器人脚本会给表单挂
        // submit 监听，无条件 preventDefault 后自行执行验证码，再调用原生
        // form.submit() 直发 POST（原生 submit 会绕过 required 校验和所有
        // submit 监听），导致空表单被提交并跳转出当前页面。
        // 在 click 上 preventDefault 可以让 submit 事件根本不会触发。
        event.preventDefault();
        event.stopImmediatePropagation();

        // 标记所有无效字段，不滚动页面（用户可见字段已有红色边框提示）
        form.querySelectorAll(':invalid').forEach(function (el) {
          el.classList.add('is-invalid');
        });

        // 聚焦第一个无效字段但不触发滚动，避免点击提交时页面上移
        const firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) {
          firstInvalid.focus({ preventScroll: true });
        }
      };

      // 用户开始输入时清除该字段的错误态
      fields.forEach(function (field) {
        field.addEventListener('input', function () {
          field.classList.remove('is-invalid');
        });
      });

      if (submitButton) {
        // click 拦截可同时覆盖鼠标点击和输入框内按 Enter（隐式提交会先派发 click）
        submitButton.addEventListener('click', blockInvalidSubmit);
      }

      form.addEventListener('submit', function (event) {
        // novalidate 已关闭原生校验，这里手动检查（兜底：无 click 的程序化提交）
        blockInvalidSubmit(event);
      });
    };

    const initAll = function (root) {
      if (root.matches && root.matches('#x-partner-inquiry-form')) {
        initForm(root);
      }
      root.querySelectorAll('#x-partner-inquiry-form').forEach(initForm);
    };

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-space-inspiration"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-section-type="x-space-inspiration"]');
    const init = function () {
      sections.forEach(function (section) {
        window.ClfCarousel.init(section, {
          breakpoint: '(min-width: 750px)',
          slideSelector: '.x-space-inspiration__slide',
          dotClass: 'x-space-inspiration__dot',
          ariaLabel: 'Go to page'
        });
      });
    };
    if (window.ClfCarousel) {
      init();
    } else {
      window.addEventListener('load', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-space-product-group"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sectionSelector = '[data-section-type="x-space-product-group"]';

    const initProductGroups = function (root) {
      const sections = [];

      if (root.matches && root.matches(sectionSelector)) {
        sections.push(root);
      }

      root.querySelectorAll(sectionSelector).forEach(function (section) {
        sections.push(section);
      });

      sections.forEach(function (section) {
        if (section.dataset.mobileProductsInitialized === 'true') return;

        const button = section.querySelector('[data-mobile-products-toggle]');
        if (!button) return;

        section.dataset.mobileProductsInitialized = 'true';

        button.addEventListener('click', function () {
          section.classList.add('is-mobile-expanded');
          section.classList.add('is-desktop-expanded');
          button.setAttribute('aria-expanded', 'true');
          button.closest('.x-space-product-group__more').hidden = true;
        });
      });
    };

    initProductGroups(document);

    document.addEventListener('shopify:section:load', function (event) {
      initProductGroups(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
